import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M4 22q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 20V6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4h4.05a.97.97 0 0 1 .712.287q.288.288.288.713c0 .425-.096.52-.288.713A.97.97 0 0 1 8.05 6H4v14h14v-5a.97.97 0 0 1 .288-.713A.97.97 0 0 1 19 14a.97.97 0 0 1 .712.287Q20 14.575 20 15v5q0 .824-.587 1.413A1.93 1.93 0 0 1 18 22zM19.3 8.9l2.5 2.5a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-2.5-2.5q-.525.3-1.125.5c-.6.2-.825.2-1.275.2q-1.875 0-3.188-1.313Q11.001 8.375 11 6.5q0-1.875 1.313-3.188Q13.625 2.001 15.5 2q1.875 0 3.188 1.313Q20 4.623 20 6.5q0 .675-.2 1.275T19.3 8.9m-3.8.1q1.05 0 1.775-.725T18 6.5c0-1.05-.242-1.292-.725-1.775Q16.55 4 15.5 4c-1.05 0-1.292.242-1.775.725Q13 5.45 13 6.5c0 1.05.242 1.292.725 1.775Q14.45 9 15.5 9M4 13.25V20 6v7-.3z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }